/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface FigmaControllerRandomRequest {
    resource: string;
}

/**
 * 
 */
export class FigmaApi extends runtime.BaseAPI {

    /**
     * get random stuff
     */
    async figmaControllerRandomRaw(requestParameters: FigmaControllerRandomRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.resource === null || requestParameters.resource === undefined) {
            throw new runtime.RequiredError('resource','Required parameter requestParameters.resource was null or undefined when calling figmaControllerRandom.');
        }

        const queryParameters: any = {};

        if (requestParameters.resource !== undefined) {
            queryParameters['resource'] = requestParameters.resource;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/figma/random`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * get random stuff
     */
    async figmaControllerRandom(requestParameters: FigmaControllerRandomRequest): Promise<void> {
        await this.figmaControllerRandomRaw(requestParameters);
    }

}
